import { Flex, Checkbox, Text } from "@chakra-ui/react";
import { OrcamentoCotacaoItem } from "features/orcamento/typings";
import colors from "core/resources/theme/colors";
import ActionsKebabMenu from "ui/components/ActionsKebabMenu";
import { MdDelete } from "react-icons/md";
import { formatMoney } from "infra/helpers/number";
import { ControllerRenderProps } from "react-hook-form";
import InputMoney from "components/Input/InputMoney/index";
import SelectMedida from "components/Input/SelectMedida/index";
import SelectItensCotados from "components/Input/SelectItensCotados/index";
import { useRef } from "react";

export default function ItemTable({
  item,
  onRemoveItem,
  indexItem,
  onEditRow,
  field,
  isInvalid,
  orcamentoId,
}: {
  item: OrcamentoCotacaoItem;
  indexItem: number;
  onEditRow: (
    field: ControllerRenderProps<any, any>,
    value: Partial<OrcamentoCotacaoItem>,
    index: number
  ) => void;
  onRemoveItem: (field: ControllerRenderProps<any, any>, index: number) => void;
  field: ControllerRenderProps<any, any>;
  isInvalid?: boolean;
  orcamentoId?: string;
}) {
  const containerRef = useRef(null);

  const total = item.quantidade! * item.valorUnitario!;
  return (
    <Flex
      ref={containerRef}
      px={4}
      pb={2}
      align="center"
      borderTop={`1px solid ${colors.gray10}`}
      gap={4}
    >
      <Flex flex={2} fontWeight="medium">
        <SelectItensCotados
          orcamentoId={orcamentoId!}
          value={item.orcamentoItemId}
          placeholder="Selecione..."
          onChange={(v) => {
            onEditRow(
              field,
              {
                orcamentoItemId: v,
              },
              indexItem
            );
          }}
        />
      </Flex>

      <Flex flex={1.5} fontWeight="medium">
        <SelectMedida
          value={item.unidadeMedidaId}
          placeholder="Selecione..."
          onChange={(v) => {
            onEditRow(
              field,
              {
                unidadeMedidaId: v,
              },
              indexItem!
            );
          }}
        />
      </Flex>
      <Flex flex={1} fontWeight="medium">
        <InputMoney
          isInvalid={isInvalid && !item.quantidade}
          onChange={(v: any) => onEditRow(field, { quantidade: v }, indexItem)}
          value={item.quantidade}
          minValue={0}
          className={
            isInvalid && !item.quantidade
              ? "chakra-input"
              : "chakra-input valid-field"
          }
        />
      </Flex>
      <Flex flex={1} fontWeight="medium" flexDir="column" pt={6}>
        <InputMoney
          key={`${item.indisponivel}`}
          disabled={item.indisponivel}
          isInvalid={isInvalid && !item.valorUnitario}
          onChange={(v: any) =>
            onEditRow(field, { valorUnitario: v }, indexItem)
          }
          value={item.valorUnitario}
          minValue={0}
          className={
            isInvalid && !item.valorUnitario
              ? "chakra-input"
              : "chakra-input valid-field"
          }
        />
        <Checkbox
          mt={1}
          onChange={() => {
            onEditRow(
              field,
              {
                indisponivel: !item.indisponivel,
                valorUnitario: !item.indisponivel
                  ? undefined
                  : item.valorUnitario,
              },
              indexItem
            );
          }}
          isChecked={!!item.indisponivel}
        >
          <Text fontSize={12}>Não tem</Text>
        </Checkbox>
      </Flex>
      <Flex
        flex={1}
        fontWeight="medium"
        justifyContent="flex-end"
        mr="25px"
        color={item.indisponivel ? colors.red : undefined}
      >
        {formatMoney(total)}
      </Flex>

      <Flex h="fit-content" py={4}>
        <ActionsKebabMenu
          actionsContainerRef={containerRef}
          indexItem={indexItem}
          item={item}
          actions={[
            {
              title: "Excluir",
              icon: () => <MdDelete />,
              onClick: () => onRemoveItem(field, indexItem),
            },
          ]}
        />
      </Flex>
    </Flex>
  );
}
